import { Component, OnInit } from '@angular/core';
import {Toast} from 'angular-toastify/lib/toast';
import {ToastService} from 'angular-toastify';
import {OrdersService} from '../../services/orders.service';
import {Card, CardExtension} from '../../../dto/card';
import {CardsService} from '../../services/cards.service';
import {OrdersBadgeService} from "../../services/orders-badge.service";

@Component({
  selector: 'app-pending-extensions',
  templateUrl: './pending-extensions.component.html',
  styleUrls: ['./pending-extensions.component.css']
})
export class PendingExtensionsComponent implements OnInit {
  pendingExtensions: CardExtension[] = [];
  isExecutingPendingExtensions = false;
  recentExtensions: CardExtension[] = [];

  constructor(
    private toastService: ToastService,
    private ordersService: OrdersService,
    private cardsService: CardsService,
    private ordersBadgeService: OrdersBadgeService,
  ) { }

  ngOnInit(): void {

   this.loadPendingExtensions();
   this.loadRecentExtensions();

  }

  loadRecentExtensions() {
    this.ordersService.getRecentCardExtensions().subscribe(extensions => {
      this.recentExtensions = extensions;
    }, err => {
      this.toastService.error(err.error.message || err.error || err.message);
    });
  }


  loadPendingExtensions() {
    this.ordersService.getCardsQueuedForExtension().subscribe(extensions => {
      this.pendingExtensions = extensions;
    }, err => {
      this.toastService.error(err.error.message || err.error || err.message);
    });
  }

  executeExtensions() {

    if ( this.pendingExtensions == null || this.pendingExtensions.length === 0 ) {
return;
}

    if ( this.isExecutingPendingExtensions ) {
return;
}

    this.isExecutingPendingExtensions = true;

    this.cardsService.executePendingExtensions().subscribe(data => {

      this.toastService.info('Adding extensions for processing...');
      setTimeout(() => this.toastService.success('Extensions added for processing'), 3000);
      setTimeout(this.loadPendingExtensions, 5000);
      setTimeout(() => {
        this.loadPendingExtensions();
        this.loadRecentExtensions();
        this.ordersBadgeService.clearCache();
        this.isExecutingPendingExtensions = false;
        }, 10000);

    }, err => {
      this.toastService.error(err.error.message || err.message || err.error || err);
      this.isExecutingPendingExtensions = false;
    });



  }
}
